import React, { useEffect } from "react";
import SEO from "../Components/Seo";
import Footer from "../Components/Nav/Footer";
import Header from "../Components/Nav/Header";
import Button from "../Components/Inputs/Button";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Client } from "../Utils/client";
import { toast } from "react-toastify";

const Contact = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  const form = useFormik({
    initialValues: {
      email: "",
      lastName: "",
      firstName: "",
      message: "",
    },
    validationSchema: Yup.object().shape({
      email: Yup.string()
        .email("Enter a valid Email")
        .required("Email is required"),
      lastName: Yup.string().required("Last Name is required"),
      firstName: Yup.string().required("First Name is required"),
      message: Yup.string().required("Message is required"),
    }),
    validateOnMount: false,
    validateOnBlur: false,
    validateOnChange: true,

    onSubmit: async (values, { setSubmitting, resetForm }) => {
      try {
        const { data } = await Client({
          method: "POST",
          path: "https://api.halvestco.com/api/v1/contact-us",
          // path: "https://apiv2-staging.halvestco.com/api/v1/contact-us",
          data: {
            email: values?.email,
            full_name: `${values?.lastName} ${values?.firstName}`,
            message: values?.message,
          },
          type: "full-path",
        });

        resetForm();
        toast.success("Message sent! We'll get back to you soon.");
      } catch (error) {
        resetForm();
        toast.error(
          error?.response?.data?.errors?.email[0] ||
            error?.response?.data?.message
        );
      }

      setSubmitting(false);
    },
  });

  return (
    // <div className="bg-[#F5F5F5] pt-6">
    <div className="bg-[#FFF] pt-6">
      <SEO title={""} description={""} name={"Halves Terms"} type={"article"} />
      <Header />
      <div className="w-full bg-[#FFF] text-[#292929] ">
        <div className="sm:m-[auto] gap-[3%] px-[1%] py-[8%] sm:py-[6%] flex flex-col  items-center sm:items-start  ">
          <div className=" w-full flex-wrap flex justify-center items-center  gap-y-10">
            <div className="w-full sm:w-[45%]">
              <div className="w-full flex flex-col gap-2">
                <div className="  w-[85%] flex-col sm:flex-row flex mx-auto gap-3 ">
                  <div className="flex-1">
                    <h4 className=" font-[400] max-w-[288px] text-[#232323]  text-[20px] 3xl:text-[20px] 4xl:text-[24px] leading-[24px] 3xl:leading-[24.24px] 4xl:leading-[31px]">
                      First Name:
                    </h4>
                    <div className="flex mx-auto gap-3 w-full  ">
                      <div className="flex-1">
                        <input
                          type="text"
                          onChange={form.handleChange}
                          value={form.values?.firstName}
                          id="firstName"
                          // placeholder="Your Full Name"
                          className="text-[16.84px] font-[400] mt-4 text-[#757B8D] rounded-[10.67px] 4xl:text-[21.33px] h-[54.5px] 4xl:h-[70.67px] border-[1.7px] border-[#ECECEC] bg-[#F8F8F8] outline-none p-[4%] w-full  "
                        />
                        {form.errors["firstName"] && (
                          <h6 className=" text-[0.75rem] mt-[4px] px-[2px] mb-2 text-[#ef5364] text-left w-full">
                            {`${form.errors["firstName"]}`}
                          </h6>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="flex-1">
                    <h4 className=" font-[400] max-w-[288px] text-[#232323]  text-[20px] 3xl:text-[20px] 4xl:text-[24px] leading-[24px] 3xl:leading-[24.24px] 4xl:leading-[31px]">
                      Last Name:
                    </h4>
                    <div className="flex mx-auto gap-3 w-full  ">
                      <div className="flex-1">
                        <input
                          onChange={form.handleChange}
                          value={form.values?.lastName}
                          id="lastName"
                          // placeholder="Your Email here"
                          className="text-[16.84px] font-[400] mt-4 text-[#757B8D] rounded-[10.67px] 4xl:text-[21.33px] h-[54.5px] 4xl:h-[70.67px] border-[1.7px] border-[#ECECEC] bg-[#F8F8F8] outline-none p-[4%] w-full  "
                        />
                        {form.errors["lastName"] && (
                          <h6 className=" text-[0.75rem] mt-[4px] px-[2px] mb-2 text-[#ef5364] text-left w-full">
                            {`${form.errors["lastName"]}`}
                          </h6>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="flex-1">
                  <h4 className=" font-[400]  mx-auto  w-[85%]  mt-5 text-[#232323]  text-[20px] 3xl:text-[20px] 4xl:text-[24px] leading-[24px] 3xl:leading-[24.24px] 4xl:leading-[31px]">
                    Email:
                  </h4>

                  <div className="flex mx-auto gap-3 w-[85%]  ">
                    <div className="flex-1">
                      <input
                        type="email"
                        onChange={form.handleChange}
                        value={form.values?.email}
                        id="email"
                        // placeholder="Your Email here"
                        className="text-[16.84px] font-[400] mt-4 text-[#757B8D] rounded-[10.67px] 4xl:text-[21.33px] h-[54.5px] 4xl:h-[70.67px] border-[1.7px] border-[#ECECEC] bg-[#F8F8F8] outline-none p-[4%] w-full  "
                      />
                      {form.errors["email"] && (
                        <h6 className=" text-[0.75rem] mt-[4px] px-[2px] mb-2 text-[#ef5364] text-left w-full">
                          {`${form.errors["email"]}`}
                        </h6>
                      )}
                    </div>
                  </div>
                </div>
                <div className="flex-1">
                  <h4 className=" font-[400]  mx-auto  w-[85%]  mt-5 text-[#232323]  text-[20px] 3xl:text-[20px] 4xl:text-[24px] leading-[24px] 3xl:leading-[24.24px] 4xl:leading-[31px]">
                    Message:
                  </h4>

                  <div className="flex mx-auto gap-3 w-[85%]  ">
                    <div className="flex-1">
                      <textarea
                        draggable
                        type="text"
                        onChange={form.handleChange}
                        value={form.values?.message}
                        id="message"
                        // placeholder="Your Message"
                        rows={4}
                        className="text-[16.84px] font-[400] mt-4 text-[#757B8D] rounded-[10.67px] 4xl:text-[21.33px]  border-[1.7px] border-[#ECECEC] bg-[#F8F8F8] outline-none p-[4%] w-full  "
                        // className="text-[11.84px] w-full border-[1px] border-[#A9A9A9] bg-[#FAFAFA] outline-none p-2"
                      />
                      {form.errors["message"] && (
                        <h6 className=" text-[0.75rem] mt-[4px] px-[2px] mb-2 text-[#ef5364] text-left w-full">
                          {`${form.errors["message"]}`}
                        </h6>
                      )}
                    </div>
                  </div>
                </div>
                <div className="w-[85%]  flex my-8 mx-auto">
                  <Button
                    onClick={form.handleSubmit}
                    loading={form.isSubmitting}
                    title={"Contact Us"}
                    classes={
                      "mt-2 4xl:text-[21.12px] 4xl:mt-4 4xl:h-[77px] !w-full"
                    }
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Contact;
